<script lang="ts" setup>
defineProps<{
	notification: App.Support.Notifications.Data.NotificationData
}>()

defineEmits(['dismiss'])
</script>

<template>
	<div
		:class="{
			'flex items-center space-x-2 rounded-md p-3': true,
			'bg-green-50 text-sm font-medium text-green-800': notification.type === 'success',
			'bg-red-50 text-sm font-medium text-red-800': notification.type === 'error',
		}"
	>
		<div>
			<i-gg-check-o v-if="notification.type === 'success'" class="size-5 text-green-400" />
			<i-gg-close-o v-if="notification.type === 'error'" class="size-5 text-red-400" />
		</div>
		<div class="w-full">
			{{ notification.message }}
		</div>
		<button class="pointer-events-auto hover:text-black" type="button" @click="$emit('dismiss')">
			<i-gg-close class="size-5" />
		</button>
	</div>
</template>
